// src/mocks/handlers/index.ts
import type { BaseQueryApi } from '@reduxjs/toolkit/query'
import { playerProgressHandler } from './playerProgress'

export interface MockRequest {
  url: string
  method: string
  body?: unknown
  api: BaseQueryApi
}

type HandlerResult = { data: unknown } | { error: { status: number; data: unknown } }

type Handler = (req: MockRequest) => Promise<HandlerResult> | HandlerResult

const routes: Array<{ pattern: RegExp; handler: Handler }> = [
  { pattern: /^player-progress\//, handler: playerProgressHandler },
]

export const handleMockRequest = async (req: MockRequest): Promise<HandlerResult> => {
  for (const { pattern, handler } of routes) {
    if (pattern.test(req.url)) return await handler(req)
  }
  return { error: { status: 404, data: { detail: `Mock route not found: ${req.url}` } } }
}
